import { Component, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'shared-auth-header',
    templateUrl: './auth-header.shared.component.html',
    styleUrls: ['./auth-header.shared.component.scss']
})
export class AuthHeaderComponent {
    @Input() public preHeader!: TemplateRef<any>;
    @Input() public description!: TemplateRef<any>;
    @Input() public preHeaderType: OLO.Components.HEADER_TYPE = '5';
    @Input() public preHeaderMarginTop: OLO.Components.MARGIN_SIZE = 'none';
    @Input() public preHeaderMarginBottom: OLO.Components.MARGIN_SIZE = 'none';
    @Input() public type: OLO.Components.HEADER_TYPE = '2';
    @Input() public marginTop: OLO.Components.MARGIN_SIZE = 'none';
    @Input() public marginBottom: OLO.Components.MARGIN_SIZE = 'lg';
    @Input() public center: boolean = false;
}
